// extracted by mini-css-extract-plugin
export default {"row":"summary-row_row__vTqOp","card":"summary-row_card__mxd08"};